(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-banner"]) return;
  try {
    
  // Imitate old webfloiw animation
  document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('scroll', function() {
        const fadeOutDiv = document.querySelector('.section-home-header');
        const scrollRange = 1200; // Adjust this to control the fading speed
    
        // Calculate current opacity based on scroll position
        let currentOpacity = 1 - window.scrollY / scrollRange;
        currentOpacity = Math.max(currentOpacity, 0); // Ensure opacity doesn't go negative
    
        // Apply the calculated opacity to the div
        fadeOutDiv.style.opacity = currentOpacity;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
